/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { RequestExpertsEditExpertDetailsRequest, ResponseExpertsGetExpertDetailsResponse } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class ExpertDetails<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags ExpertDetails
   * @name GetExpertDetails
   * @summary  (Auth policies: SupportPolicy)
   * @request GET:/api/v1/expert-details/{userId}
   * @secure
   * @response `200` `ResponseExpertsGetExpertDetailsResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getExpertDetails = (userId: string, params: RequestParams = {}) =>
    this.http.request<ResponseExpertsGetExpertDetailsResponse, void>({
      path: `/api/v1/expert-details/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ExpertDetails
   * @name UpdateExpertDetails
   * @summary  (Auth policies: SupportPolicy)
   * @request PATCH:/api/v1/expert-details/{userId}
   * @secure
   * @response `200` `ResponseExpertsGetExpertDetailsResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateExpertDetails = (userId: string, data: RequestExpertsEditExpertDetailsRequest, params: RequestParams = {}) =>
    this.http.request<ResponseExpertsGetExpertDetailsResponse, void>({
      path: `/api/v1/expert-details/${userId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
